import { useDispatch } from "react-redux";
import { Button, Input } from "../../../../components/ui";
import useBenficiaryOtpVerification from "./useBenPayoutOtpVerication";
import { FC } from "react";

const BenPayoutOtpVerification: FC<{
  type: string;
}> = ({ type }) => {
  const { sendOtpApiCall, onVerifyOtp, otpVal, setOtpVal, refId } =
    useBenficiaryOtpVerification({ type: type });

  return (
    <div>
      <div className="text-sm font-bold mt-9 mb-2">OTP Verification</div>
      <div className="flex justify-between  py-2">
        <div className="flex flex-col grow-[3] mr-5">
          <div className="flex justify-between">
            <div className="flex   fs-14">
              Enter OTP <span className="color-red">*</span>
            </div>
            <div
              className={`fs-14 ${refId.length > 0
                  ? "text-gray-400 cursor-not-allowed"
                  : "color-blue cursor-pointer"
                }`}
              onClick={() => {
                sendOtpApiCall(type);
              }}
            >
              Resend Otp
            </div>
          </div>
          <div>
            <Input
              type="number"
              label={""}
              value={otpVal}
              onChange={(e) => {
                setOtpVal(e.target.value);
              }}
              disabled={refId.length > 0}
            />
          </div>
        </div>
        <div className="flex flex-col grow-[1] pt-1">
          <span className="h-[25px]">{""}</span>
          <Button
            variant="contained"
            disabled={refId.length > 0}
            onClick={() => {
              onVerifyOtp();
            }}
          >
            {refId.length > 0 ? "VERIFIED" : "VERIFY"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BenPayoutOtpVerification;
